// document.addEventListener("DOMContentLoaded", function() {
//     // 1. Force your global variable first
//     window.recurpay = window.recurpay || {};
//     window.recurpay.shopDomainURL = 'https://deyga.recurpay.com';
//     window.recurpay.checkout = 'recurpay';
//      window.recurpay.checkout_btn_override_class = ".icart-checkout-btn, .hs-checkout-purchase, .recurpay-custom-checkout-btn, .gokwik-checkout button, .checkoutbtns, .svelte-yb4nuo";
//       window.recurpay.recurCart = function(cartData){
//         var checkoutData = [],
//             cartItems = cartData.items,
//             cartAttributes = [],
//             cartNote = cartData.note,
//             recurpayCheckout = false;
//         $.each( cartData.attributes, function(key, value ) {
//           if(key != "Plan" && key != 'PlanId'){
//             cartAttributes.push({
//               name: key,
//               value:value
//             });
//           }
//         });
//         for(var i=0; i < cartItems.length; i++){
//           var Planid = '',
//               item = cartItems[i],
//               property = item.properties,
//               lineProperty = [];
//           if(property){
//             if(property.PlanId){
//               Planid = property.PlanId
//               recurpayCheckout = true;
//             }
//             $.each( property, function(key, value ) {
//               if(key != "Plan" && key != 'PlanId'){
//                 lineProperty.push({
//                   name: key,
//                   value:value
//                 });
//               }
//             });
//           }
//           if(Planid == ''){
//             checkoutData.push({
//               quantity: item.quantity,
//               variant_id: item.id,
//               properties: lineProperty,
//               type: 'ONETIME',
//               currency:'INR'
//             });
//           }
//           else{
//             checkoutData.push({
//               quantity: item.quantity,
//               variant_id: item.id,
//               properties: lineProperty,
//               plan_id: Planid,
//               type: 'SUBSCRIPTION',
//               currency:'INR'
//             });
//           }
//         }
//         if(recurpayCheckout) {
//           var getCheckoutData = JSON.stringify(checkoutData),
//               getCartAttributes = JSON.stringify(cartAttributes),
//               cartNote = $('[name="note"]').val();
//           checkoutForm = $("<form action='"+recurpay.checkoutAPI+"' method='post' style='display:none;'>" +
//                            "<input type='hidden' name='line_items' value='"+getCheckoutData+"' />"+
//                            "<input type='hidden' name='customer_id' value='"+recurpay.customer+"' />" +
//                            "<input type='hidden' name='note_attributes' value='"+getCartAttributes+"' />" +
//                            "<input type='hidden' name='note' value='"+cartNote+"' />" +
//                            "</form>");
//           $('body').append(checkoutForm);
//           Promise.resolve().then(function () {
//             checkoutForm.submit();
//           });
//         }
//         else {
//           onCheckoutClick(document.querySelector('.gokwik-checkout'));          
//         }
//       }

//       if (window.recurpay.checkout == "recurpay") {
//        // Use delegation on document to catch dynamically loaded cart drawers
//         $(document).on("click", window.recurpay.checkout_btn_override_class , function(e) {
//             // Check if the cart contains a subscription item
//             // If your script logic relies on a specific class (like .pdp_sub) to identify subscription carts, 
//             // ensure that class is being added to the cart drawer body.
//             e.preventDefault();
//             e.stopImmediatePropagation();
//             // alert("Recurpay Checkout Triggered");
//             $.getJSON('/cart.js', function(cart) {
//                 // Force recurpay checkout if any item has a 'PlanId' property
//                 var hasSubscription = false;
//                 for (var i = 0; i < cart.items.length; i++) {
//                     if (cart.items[i].properties && cart.items[i].properties.PlanId) {
//                         hasSubscription = true;
//                         break;
//                     }
//                 }
//                 if (hasSubscription) {
//                     recurpay.recurCart(cart);
//                 } else {
//                     // If no subscription, proceed to standard checkout or GoKwik
//                     window.location.href = '/checkout';
//                 }
//             });
//         });
//       }

   
//     // console.log("DOM fully loaded: Recurpay checkout set to 'recurpay'");

//     $(document).on('click', "button[data-recurpay-action]", function (e) {
//       e.preventDefault();
//       e.stopPropagation();
//        e.stopImmediatePropagation(); 
//       //  alert("hello");
//       addSubscriptionNew();
//     });

//     function addSubscriptionNew() {
//     // console.log("=== addSubscription() called ===");

//     var pdpSelector = document.querySelector(".recurpay-pdp-widget");
//     // console.log("pdpSelector:", pdpSelector);
//     var packofoption = parseInt($('input[name="assortment"]:checked').val());
//       if(packofoption == 2){
//         var variantSelector = '42792403534018';
//       } else if(packofoption == 3){
//           var variantSelector = '42792403566786';
//       }else{
//           var variantSelector = $(pdpSelector).parents('.product__info-container').find('[name="id"]').val();
//       }   
//     var quantitySelector = $(pdpSelector).parents('.product__info-container').find('[name="quantity"]');

//     var subscriptionPlanId = $('[name="recurpay-input"] option:selected').attr('data-plan');
//     var subscriptionPlanName = $('[name="recurpay-input"] option:selected').attr('data-plan-name');
//     var subscriptionPlanType = $('[name="recurpay-input"] option:selected').attr('data-plan-type');

//     var heavy = parseInt($('.main_value').eq(0).text());
//     var medium = parseInt($('.main_value').eq(1).text());
//     var light = parseInt($('.main_value').eq(2).text());


//     var planVariant = parseInt(variantSelector);
//     var planQuantity = 1;
//     var planParams = {};
    
//     // console.log("variantSelector:", variantSelector, "value:", planVariant);
//     // console.log("quantitySelector:", quantitySelector);

//     // if (quantitySelector.length) {
//     //   planQuantity = parseInt(quantitySelector.val());
//     // }

//     // console.log("planQuantity:", planQuantity);

//     // ================= SHOPIFY CHECKOUT =================
//     if (recurpay.checkout == "shopify") {
//       console.log("------------shopify")

//       var sellingPlanId = $('[name="recurpay-input"] option:selected').attr('data-plan');
//       console.log("sellingPlanId:", sellingPlanId);

      
//       planParams = {
//         id: planVariant,
//         quantity: planQuantity,
//         selling_plan: sellingPlanId,
//         properties: {
//           'Plan': subscriptionPlanName,
//           'PlanId': subscriptionPlanId,
//           'sellingid':sellingPlanId,
//           'Heavy (XXL)': heavy,
//           'Medium (XL)': medium,
//           'Light (L)': light
//         }
//       };

//     } else {
//       console.log("------------Non-shopify")
//       // ================= NON-SHOPIFY CHECKOUT =================
//       planParams = {
//         id: planVariant,
//         quantity: planQuantity,
//         selling_plan: sellingPlanId,
        
//         properties: {
//           'Plan': subscriptionPlanName,
//           'PlanId': subscriptionPlanId,
//           'sellingid':sellingPlanId,
//           '_Heavy (XXL)': heavy,
//           '_Medium (XL)': medium,
//           '_Light (L)': light
//         }
//       };
//     }
//   // console.log("planParams ready to send:", planParams);
//     $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           dataType: 'json',
//           data: planParams,
//           success: function (productid) {
//             // console.log("Added:", productid);
//             // alert(window.recurpay.checkout);
//             // alert(window.recurpay.action);
//             if (window.recurpay.checkout == "recurpay"){
//                     $.getJSON('/cart', function(response) {
//                       recurpay.recurCart(response);
//                     });
//                   }else{
//                     document.dispatchEvent(new CustomEvent('cart:refresh'));
//                   }
//           },
//           error: function (xhr) {
//             var err = eval("(" + xhr.responseText + ")");
//             // console.error("Error adding product:", err);

//             $('[data-recurpay-error]')
//               .html(err.description)
//               .show()
//               .delay(3000)
//               .fadeOut();
//           }
//         });
//     // console.log("=== addSubscription() finished ===");
//     return false;
//   }

  
// });

//    /************************************************************************************ */
//       (function() {
//   const observer = new MutationObserver(() => {
//     const recurpayWidget = document.querySelector(".recurpay-pdp-widget");
//     // console.log('----recurpayWidget-----',recurpayWidget);
//     if (!recurpayWidget) return;
//     const twoTimePurchase = recurpayWidget.querySelector(
//       '.recurpay__widget_container[data-type="subscription-purchase"]'
//     );
//     if (!twoTimePurchase) return;
//     if (twoTimePurchase.classList.contains("auto-triggered")) return;
//     // console.log("Triggering two-time purchase automatically...");
//     twoTimePurchase.click();
//     let recurpay__action = document.querySelector(".recurpay__action button");
//     recurpay__action.style.pointerEvents = "none";
//     recurpay__action.style.opacity = "0.5";
//     twoTimePurchase.classList.add("auto-triggered");
//     const offerAppliedDiv = document.querySelector(".offer-applied-div");
//     if (offerAppliedDiv) offerAppliedDiv.style.display = "none";
//     const additionalOfferDiv = document.querySelector(".offer-applied-div");
//     const hiddenLiquidDiv = document.querySelector(".additional_offer_information");
//     if (additionalOfferDiv && hiddenLiquidDiv && !additionalOfferDiv.parentNode.querySelector(".cloned-offer-info")) {
//       const clone = hiddenLiquidDiv.cloneNode(true);
//       clone.style.display = "block";
//       clone.classList.add("cloned-offer-info");
//       additionalOfferDiv.parentNode.insertBefore(clone, additionalOfferDiv.nextSibling);
//       // console.log("Hidden offer information cloned");
//        function enableRecurpayButton() {
//         // console.log(enableRecurpayButton)
//         var checkBtn = setInterval(function () {
//           var btn = document.querySelector(".recurpay__action button");
//           if (btn) {
//             btn.style.pointerEvents = "auto";
//             btn.style.opacity = "1";
//             clearInterval(checkBtn);
//             // console.log("Recurpay button enabled");
//           }
//         }, 300);
//       }
//       enableRecurpayButton();
//     }
//     // Select first dropdown frequency item
//     const ul = document.querySelector(".dropdown-custom-frequency-list");
//     if (!ul) return;
//     const firstLi = ul.querySelector(".dropdown-custom-frequency-item");
//     if (!firstLi) return;
//     setTimeout(() => {
//       firstLi.click();
//       const priceSpan = firstLi.querySelector("span:last-of-type");
//       const price = priceSpan ? priceSpan.textContent : "0";
//       const dropdownSelected = document.querySelector(".dropdown-custom-selected");
//       if (dropdownSelected) {
//         let dropdownPriceSpan = dropdownSelected.querySelector("span:last-of-type");
//         if (!dropdownPriceSpan) {
//           dropdownPriceSpan = document.createElement("span");
//           dropdownSelected.appendChild(dropdownPriceSpan);
//         }
//         dropdownPriceSpan.textContent = price.toFixed(0);
//       }
//       const offerContainer = document.querySelector(".offer-price-container");
//       if (offerContainer) offerContainer.textContent = "";
      

//     }, 500);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });
// })();

// /*************************************************************************************** */
// (function () {
//   function handleRecurpayWidget() {
//     const widget = document.querySelector(".recurpay-pdp-widget");
//      let recurpay__action = document.querySelector(".recurpay__action button");
//     if (!widget || widget.dataset.listenerAttached) return;
//     widget.dataset.listenerAttached = "true";
//     widget.addEventListener("click", function (e) {
//       const oneTime = e.target.closest(
//         '.recurpay__widget_container[data-type="onetime-purchase"]'
//       );
//       const subscription = e.target.closest(
//         '.recurpay__widget_container[data-type="subscription-purchase"]'
//       );

//       if (oneTime) handleOneTimePurchase();
//       if (subscription) handleSubscriptionPurchase();
//     });
//     // addCustomSubscription();
//   }
//   function handleOneTimePurchase() {
//       let parent = document.querySelector('.recurpay__group_label[for="recurpay__onetime_radio"]');
//       if (parent) {
//           let cstm_onetime_price = parent.querySelector('.recurpay__group_selling_price span.money').textContent.trim();
//           // console.log("-----cstm_onetime_price------"+cstm_onetime_price);
//           // alert(cstm_onetime_price);
//           // console.log("--------------------cstm_onetime_price"+cstm_onetime_price);
//           $('.price-item.price-item--regular.signle_price').text(cstm_onetime_price);
//           $('.main_product_price .price-item.price-item--sale.price-item--last').text(cstm_onetime_price);
          
//       }

      
//       const block = document.querySelector(".shopify-block.shopify-app-block");
//       const price = document.querySelector(".main_product_price");
//       const button = document.querySelector(".customize_button");

//       if (block) {
//         block.classList.add("one-time-purchase");
//         block.classList.remove("two-time-purchase");
//       }

//       if (price) price.style.display = "inline-block";
//       if (button) button.style.display = "inline-block";




//   }
//   function handleSubscriptionPurchase() {
//     const block = document.querySelector(".shopify-block.shopify-app-block");
//     const price = document.querySelector(".main_product_price");
//     const button = document.querySelector(".customize_button");

//     if (block) {
//       block.classList.add("two-time-purchase");
//       block.classList.remove("one-time-purchase");
//     }

//     if (price) price.style.display = "none";
//     if (button) button.style.display = "none";

//     buildFrequencyDropdown();
   
//   }

//   function buildFrequencyDropdown() {
//     const select = document.querySelector(
//       ".recurpay__frequency_select.recurpay__frequency"
//     );

//     if (!select) return;
//     if (document.querySelector(".dropdown-custom-wrapper")) return;

//     select.style.display = "none";

//     const basePriceEl = document.querySelector(
//       ".recurpay__group_selling_price.recurpay__group_discounted_price .money"
//     );

//     const basePriceText = basePriceEl
//       ? basePriceEl.textContent.trim()
//       : "₹0";

//     const currency = basePriceText.match(/[^\d.,]/)?.[0] || "₹";
//     const numericBasePrice = parseFloat(
//       basePriceText.replace(/[^\d.]/g, "")
//     ) || 0;

//     const wrapper = document.createElement("div");
//     wrapper.className = "dropdown-custom-wrapper";

//     const label = document.createElement("label");
//     label.className = "dropdown-custom-label";
//     label.textContent = "Choose Frequency";

//     const selectedDiv = document.createElement("div");
//     selectedDiv.className = "dropdown-custom-selected";
//     selectedDiv.textContent = "Choose Frequency";

//     const ul = document.createElement("ul");
//     ul.className = "dropdown-custom-frequency-list";

//     wrapper.appendChild(label);
//     wrapper.appendChild(selectedDiv);
//     wrapper.appendChild(ul);

//     select.parentNode.insertBefore(wrapper, select.nextSibling);

//     const badgeMap = {};
//     document.querySelectorAll(
//       ".subscription_badge_plan .frequency_subscription_item"
//     ).forEach(item => {
//       const planName = item.dataset.planName?.trim();
//       const badgeSpan = item.querySelector(".frequency_badge");
//       if (planName && badgeSpan) {
//         badgeMap[planName] = badgeSpan.textContent.trim();
//       }
//     });

//     Array.from(select.options).forEach(option => {

//       const li = document.createElement("li");
//       li.classList.add("dropdown-custom-frequency-item", "recurpay__plan");

//       const cleanText = option.textContent.trim();
//       const discountPercent =
//         parseFloat(option.dataset.planDiscount) || 0;

//       const discountedPrice =
//         numericBasePrice -
//         (numericBasePrice * discountPercent) / 100;

//       const finalPrice =
//         discountPercent > 0
//           ? discountedPrice
//           : numericBasePrice;
//       li.appendChild(
//         document.createTextNode(cleanText + " ")
//       );
//       if (badgeMap[cleanText]) {
//         const badge = document.createElement("span");
//         badge.className = "frequency_badge";
//         badge.textContent = badgeMap[cleanText];
//         li.appendChild(badge);
//       }

//       const priceSpan = document.createElement("span");
//       priceSpan.className = "frequency_price";
//       priceSpan.textContent =
//         currency + finalPrice.toFixed(0);

//       li.appendChild(priceSpan);

//       Object.keys(option.dataset).forEach(key => {
//         li.dataset[key] = option.dataset[key];
//       });

//       li.addEventListener("click", function () {

//         document
//           .querySelectorAll(".dropdown-custom-frequency-item.recurpay__plan")
//           .forEach(item => item.classList.remove("active","selected-box"));

//         li.classList.add("active");
//         li.classList.add("selected-box");


//     let planId = $(this).data('plan');


//     $('.recurpay__frequency_select option').removeAttr('selected');

  
//     let matchingOption = $('.recurpay__frequency_select option').filter(function () {
//         return $(this).data('plan') == planId;
//     });


//     matchingOption.attr('selected', 'selected');
//     $('.recurpay__frequency_select').trigger('change');
//        if (select) {
//             const optionToSelect = select.querySelector(
//               `option[data-selling-plan="${option.dataset.sellingPlan}"]`
//             );

//             if (optionToSelect) {
//               select.value = optionToSelect.value;
//               optionToSelect.selected = true;
//               select.dispatchEvent(new Event("change", { bubbles: true }));
//             }
//           }

//         document
//           .querySelectorAll(".recurpay_selling_plan_id")
//           .forEach(el =>
//             el.value = option.dataset.sellingPlan
//           );

//         const selectedPrice = priceSpan.textContent.trim().replace(/\.00\b/, '');
//         // alert("selectedPrice"+selectedPrice);
//         document.querySelectorAll(
//           '.price-item.price-item--regular.signle_price, .price__sale .price-item.price-item--sale.price-item--last'
//         ).forEach(el => el.textContent = selectedPrice);
//           let moneyElements = document.querySelectorAll(
//             '.recurpay__group_selling_price.recurpay__group_discounted_price span.money'
//           );
//           // console.log("---------------moneyElements"+moneyElements)
//           // moneyElements.forEach(el => {
//           //   el.innerHTML = selectedPrice;

//           //   let selectedBox = document.querySelector(".selected-qnty-box[checked]");
//           //   if (!selectedBox) return;

//           //   let priceElement = selectedBox.querySelector(".boxes-price");
//           //   if (!priceElement) return;

//           //   let comparePrice = parseFloat(priceElement.dataset.cprice) || 0;

//           //   if (comparePrice > 0) {

//           //     let strike = document.createElement("span");
//           //     strike.className = "cp-strike";
//           //     strike.style.textDecoration = "line-through";
//           //     strike.style.color = "#888";
//           //     strike.style.marginLeft = "6px";
//           //     strike.textContent = "₹" + comparePrice;

//           //     // ✅ money ke ANDAR add karo
//           //     el.appendChild(strike);
//           //   }

//           // });
//           moneyElements.forEach(el => {

//     el.innerHTML = selectedPrice;

//     // ✅ checked input find karo
//     let selectedInput = document.querySelector(".input-label-wrapper input:checked");
//     if (!selectedInput) return;

//     let selectedBox = selectedInput.closest(".input-label-wrapper");
//     if (!selectedBox) return;

//     let priceElement = selectedBox.querySelector(".boxes-price");
//     if (!priceElement) return;

//     let comparePrice = parseFloat(priceElement.dataset.cprice) || 0;

//     if (comparePrice > 0) {

//         let strike = document.createElement("span");
//         strike.className = "cp-strike";
//         strike.style.textDecoration = "line-through";
//         strike.style.color = "#888";
//         strike.style.marginLeft = "6px";
//         strike.textContent = " ₹" + comparePrice;

//         el.appendChild(strike);
//     }

// });
//          let priceEl = this.querySelector(".frequency_price");
//             let frequencyPrice = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) : 0;
//             // console.log("Frequency Price:", frequencyPrice);
        
//                   // 👉 Get selected quantity radio
//             let selectedRadio = document.querySelector('input[name="assortment"]:checked');
//             let discountAmount = 0;
//             if (selectedRadio) {

//             let wrapper = selectedRadio.closest('.input-label-wrapper');
//             let boxPriceSpan = wrapper.querySelector('.boxes-price');

//             if (boxPriceSpan) {
//             let cprice = parseFloat(boxPriceSpan.getAttribute('data-cprice')) || 0;
//             let data_price = parseFloat(boxPriceSpan.getAttribute('data-price')) || 0;
//             if (cprice > 0) {
//              discountAmount = Math.max(0, cprice - frequencyPrice);
//             }
//             else{
//               if(cprice == 0){
//                  discountAmount = Math.max(0, data_price - frequencyPrice);
//               }
              
//             }
//            }
//            }

//         // console.log("Discount Amount:", discountAmount);

//         // 👉 Update offer container
//         let offerContainer = document.querySelector(".offer-price-container");
//         // if (offerContainer) {
//         //     // offerContainer.textContent = "₹" + parseFloat(discountAmount).toFixed(0);
//         //     offerContainer.textContent =
//         //     (parseFloat(discountAmount) || 0) === 0 
//         //         ? "" 
//         //         : "₹" + parseFloat(discountAmount).toFixed(0);
//         // }

//         let discountValue = parseFloat(discountAmount) || 0;
//         let offerBadge = document.querySelector(".offer-price-badge");

//         if (offerContainer) {

//             if (discountValue === 0) {
//                 offerContainer.textContent = "";

//                 if (offerBadge) {
//                     offerBadge.style.display = "none";
//                 }

//             } else {
//                 offerContainer.textContent = "₹" + discountValue.toFixed(0);

//                 if (offerBadge) {
//                     offerBadge.style.display = "block";
//                 }
//             }
//         }

//         selectedDiv.innerHTML = "";

//         selectedDiv.appendChild(
//           document.createTextNode(cleanText + " ")
//         );

//         if (badgeMap[cleanText]) {
//           const badge = document.createElement("span");
//           badge.className = "frequency_badge";
//           badge.textContent = badgeMap[cleanText];
//           selectedDiv.appendChild(badge);
//         }

//         const selectedPriceClone =
//           document.createElement("span");
//         selectedPriceClone.className = "frequency_price";
//         selectedPriceClone.textContent = selectedPrice;

//         selectedDiv.appendChild(selectedPriceClone);

//         selectedDiv.classList.remove("active");
//         ul.classList.remove("show_dropdown");
//       });

//       ul.appendChild(li);
//     });

//     selectedDiv.addEventListener("click", function (e) {
//       e.stopPropagation();
//       selectedDiv.classList.toggle("active");
//       ul.classList.toggle("show_dropdown");
//     });

//     document.addEventListener("click", function () {
//       ul.classList.remove("show_dropdown");
//     });
//   }
//   const observer = new MutationObserver((mutations, obs) => {
//     if (document.querySelector(".recurpay-pdp-widget")) {
//       handleRecurpayWidget();
//       obs.disconnect();
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();







document.addEventListener("DOMContentLoaded", function() {
    // 1. Force your global variable first
    window.recurpay = window.recurpay || {};
    window.recurpay.shopDomainURL = 'https://deyga.recurpay.com';
    window.recurpay.checkout = 'recurpay';
    window.recurpay.pdpSelector = ".recurpay-pdp-widget";
    window.recurpay.checkout_btn_override_class = ".icart-checkout-btn, .hs-checkout-purchase, .recurpay-custom-checkout-btn, .gokwik-checkout button, .checkoutbtns, .svelte-yb4nuo";
    window.recurpay.recurCart = function(cartData){
    var checkoutData = [],
        cartItems = cartData.items,
        cartAttributes = [],
        cartNote = cartData.note,
        recurpayCheckout = false;

    // Cart attributes (except Plan/PlanId)
    $.each(cartData.attributes, function(key, value) {
        if(key != "Plan" && key != "PlanId"){
            cartAttributes.push({
                name: key,
                value: value
            });
        }
    });

    // Properties to hide in checkout
    var hidePropertiesInCheckout = ["Heavy (XXL)", "Medium (XL)", "Light (L)"];

    for(var i = 0; i < cartItems.length; i++){
        var Planid = '',
            item = cartItems[i],
            property = item.properties,
            lineProperty = [];

        if(property){

            // Subscription check
            if(property.PlanId){
                Planid = property.PlanId;
                recurpayCheckout = true;
            }

            // Build lineProperty, but hide heavy/medium/light in checkout
            $.each(property, function(key, value){
                if(key != "Plan" && key != "PlanId" && !hidePropertiesInCheckout.includes(key)){
                    lineProperty.push({
                        name: key,
                        value: value
                    });
                }
            });
        }

        // Push to checkoutData
        if(Planid == ''){
            checkoutData.push({
                quantity: item.quantity,
                variant_id: item.id,
                properties: lineProperty,
                type: 'ONETIME',
                currency: 'INR'
            });
        } else {
            checkoutData.push({
                quantity: item.quantity,
                variant_id: item.id,
                properties: lineProperty,
                plan_id: Planid,
                type: 'SUBSCRIPTION',
                currency: 'INR'
            });
        }
    }
      if(recurpayCheckout) {
          var getCheckoutData = JSON.stringify(checkoutData),
              getCartAttributes = JSON.stringify(cartAttributes),
              cartNote = $('[name="note"]').val();
          checkoutForm = $("<form action='"+recurpay.checkoutAPI+"' method='post' style='display:none;'>" +
                           "<input type='hidden' name='line_items' value='"+getCheckoutData+"' />"+
                           "<input type='hidden' name='customer_id' value='"+recurpay.customer+"' />" +
                           "<input type='hidden' name='note_attributes' value='"+getCartAttributes+"' />" +
                           "<input type='hidden' name='note' value='"+cartNote+"' />" +
                           "</form>");
          $('body').append(checkoutForm);
          Promise.resolve().then(function () {
            checkoutForm.submit();
          });
        }
        else {
          onCheckoutClick(document.querySelector('.gokwik-checkout'));          
        }
      }

      if (window.recurpay.checkout == "recurpay" ) {
       // Use delegation on document to catch dynamically loaded cart drawers
        $(document).on("click", window.recurpay.checkout_btn_override_class , function(e) {
            // Check if the cart contains a subscription item
            // If your script logic relies on a specific class (like .pdp_sub) to identify subscription carts, 
            // ensure that class is being added to the cart drawer body.
            e.preventDefault();
            e.stopImmediatePropagation();
            // alert("Recurpay Checkout Triggered");
            $.getJSON('/cart.js', function(cart) {
                // Force recurpay checkout if any item has a 'PlanId' property
                var hasSubscription = false;
                for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].properties && cart.items[i].properties.PlanId) {
                        hasSubscription = true;
                        break;
                    }
                }
                if (hasSubscription) {
                    recurpay.recurCart(cart);
                } else {
                    // If no subscription, proceed to standard checkout or GoKwik
                    window.location.href = '/checkout';
                }
            });
        });
      }
    // console.log("DOM fully loaded: Recurpay checkout set to 'recurpay'");
    $(document).on('click', "button[data-recurpay-action]", function (e) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation(); 
          //  alert("hello");
          addSubscriptionNew();
          recurpayClicked();
    });
    function updateCartBubble() {
       let cartCount = null;
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cartCount = cart.item_count;
          console.log("cartCount"+cartCount);
    
          const cartBubble = document.querySelector('.cart-count-bubble');
    
          if (cartCount > 0) {
            cartBubble.textContent = cartCount;
            cartBubble.classList.remove('hide');
          } else {
            cartBubble.classList.add('hide');
          }
        })
        .catch(error => console.error('Cart update error:', error));
    }
    function addSubscriptionNew() {
    // console.log("=== addSubscription() called ===");
    var pdpSelector = document.querySelector(".recurpay-pdp-widget");
    // console.log("pdpSelector:", pdpSelector);
    var packofoption = parseInt($('input[name="assortment"]:checked').val());
      if(packofoption == 2){
        var variantSelector = '42792403534018';
      } else if(packofoption == 3){
          var variantSelector = '42792403566786';
      }else{
          var variantSelector = $(pdpSelector).parents('.product__info-container').find('[name="id"]').val();
      }   
    var quantitySelector = $(pdpSelector).parents('.product__info-container').find('[name="quantity"]');
    var subscriptionPlanId = $('[name="recurpay-input"] option:selected').attr('data-plan');
    var subscriptionPlanName = $('[name="recurpay-input"] option:selected').attr('data-plan-name');
    var subscriptionPlanType = $('[name="recurpay-input"] option:selected').attr('data-plan-type');



      /* ================= NEW LOGIC TO MATCH SELLING PLAN ================= */
      var sellingPlanId = '';

      $('.recurpay-selling-plan .cstm-selling-plan').each(function () {
          var planNameAttr = $(this).attr('plan_name').trim();
          if (planNameAttr === subscriptionPlanName.trim()) {
              sellingPlanId = $(this).text().trim();
              return false; // break loop
          }
      });

      // console.log("Matched sellingPlanId:", sellingPlanId);
  /* ================= END NEW LOGIC ================= */



    var heavy = parseInt($('.main_value').eq(0).text());
    var medium = parseInt($('.main_value').eq(1).text());
    var light = parseInt($('.main_value').eq(2).text());
    var planVariant = parseInt(variantSelector);
    var planQuantity = 1;
    var planParams = {};
    // console.log("variantSelector:", variantSelector, "value:", planVariant);
    // console.log("quantitySelector:", quantitySelector);
    // if (quantitySelector.length) {
    //   planQuantity = parseInt(quantitySelector.val());
    // }
    // console.log("planQuantity:", planQuantity);
    // ================= SHOPIFY CHECKOUT =================
    
  if (recurpay.checkout == "shopify") {
      // console.log("------------shopify")

      // var sellingPlanId = $('[name="recurpay-input"] option:selected').attr('data-plan');
      // console.log("sellingPlanId:", sellingPlanId);

      
      planParams = {
        id: planVariant,
        quantity: planQuantity,
        selling_plan: sellingPlanId,
        properties: {
          'Plan': subscriptionPlanName,
          'PlanId': subscriptionPlanId,
          'sellingid':sellingPlanId,
          'Heavy (XXL)': heavy,
          'Medium (XL)': medium,
          'Light (L)': light
        }
      };

    } else {
      // console.log("------------Non-shopify")
      // ================= NON-SHOPIFY CHECKOUT =================
      planParams = {
        id: planVariant,
        quantity: planQuantity,
        selling_plan: sellingPlanId,
        properties: {
          'Plan': subscriptionPlanName,
          'PlanId': subscriptionPlanId,
          'sellingid':sellingPlanId,
          'Heavy (XXL)': heavy,
          'Medium (XL)': medium,
          'Light (L)': light
        }
      };
    }
    $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: planParams,
          success: function (productid) {
            // console.log("Added:", productid);
            // alert(window.recurpay.checkout);
            // alert(window.recurpay.action);
             updateCartBubble();
             
            // if (window.recurpay.checkout == "recurpay"){
            //         $.getJSON('/cart', function(response) {
            //           recurpay.recurCart(response);
            //         });
            //       }else{
                    document.dispatchEvent(new CustomEvent('cart:refresh'));
                  // }
          },
          error: function (xhr) {
            var err = eval("(" + xhr.responseText + ")");
            // console.error("Error adding product:", err);

            $('[data-recurpay-error]')
              .html(err.description)
              .show()
              .delay(3000)
              .fadeOut();
          }
        });
    // console.log("=== addSubscription() finished ===");
    return false;
  }

  
});

function recurpayClicked() {
    // console.log("Button clicked");
    if (typeof window.recurpay === "undefined") {
        console.log("window.recurpay not found");
        return;
    }
    if (window.recurpay.checkout !== "recurpay") {
        // console.log("Checkout type is not recurpay:", window.recurpay.checkout);
        return;
    }
    // console.log("Checkout type is recurpay");
    // console.log("Override class:", window.recurpay.checkout_btn_override_class);
    const waitForGoKwik = setInterval(function () {
        if (window.gokwikSdk && window.gokwikSdk.initCheckout) {
            clearInterval(waitForGoKwik);
            const originalInitCheckout = window.gokwikSdk.initCheckout;
            window.gokwikSdk.initCheckout = function (merchantInfo) {
                // console.log("Custom logic before GoKwik checkout");
                $.getJSON('/cart.js', function (cart) {
                    // console.log("Cart data:", cart);

                    let hasSubscription = cart.items.some(item => item.properties && item.properties.PlanId);

                    if (hasSubscription) {
                        console.log("Subscription item found → calling recurpay.recurCart()");
                        recurpay.recurCart(cart);
                    } else {
                        console.log("No subscription → calling original GoKwik checkout");
                        originalInitCheckout.call(window.gokwikSdk, merchantInfo);
                    }
                });
            };

            console.log("GoKwik initCheckout successfully overridden");
            if (window.recurpay.checkout_btn_override_class) {
                document.querySelectorAll(`.icart-checkout-btn, .hs-checkout-purchase, .recurpay-custom-checkout-btn, .gokwik-checkout button, .checkoutbtns, .svelte-yb4nuo`).forEach(btn => {
                    btn.addEventListener('click', function (e) {
                        e.preventDefault();
                        window.gokwikSdk.initCheckout();
                    });
                });
            }
        }
    }, 300);
}

document.addEventListener('DOMContentLoaded', recurpayClicked);
(function() {
  const observer = new MutationObserver(() => {
    const recurpayWidget = document.querySelector(".recurpay-pdp-widget");
    // console.log('----recurpayWidget-----',recurpayWidget);
    if (!recurpayWidget) return;
    const twoTimePurchase = recurpayWidget.querySelector(
      '.recurpay__widget_container[data-type="subscription-purchase"]'
    );
    if (!twoTimePurchase) return;
    if (twoTimePurchase.classList.contains("auto-triggered")) return;
    // console.log("Triggering two-time purchase automatically...");
    twoTimePurchase.click();
    let recurpay__action = document.querySelector(".recurpay__action button");
    recurpay__action.style.pointerEvents = "none";
    recurpay__action.style.opacity = "0.5";
    twoTimePurchase.classList.add("auto-triggered");
    const offerAppliedDiv = document.querySelector(".offer-applied-div");
    if (offerAppliedDiv) offerAppliedDiv.style.display = "none";
    const additionalOfferDiv = document.querySelector(".offer-applied-div");
    const hiddenLiquidDiv = document.querySelector(".additional_offer_information");
    if (additionalOfferDiv && hiddenLiquidDiv && !additionalOfferDiv.parentNode.querySelector(".cloned-offer-info")) {
      const clone = hiddenLiquidDiv.cloneNode(true);
      clone.style.display = "block";
      clone.classList.add("cloned-offer-info");
      additionalOfferDiv.parentNode.insertBefore(clone, additionalOfferDiv.nextSibling);
      // console.log("Hidden offer information cloned");
    }
    function enableRecurpayButton() {
        // console.log(enableRecurpayButton)
        var checkBtn = setInterval(function () {
          var btn = document.querySelector(".recurpay__action button");
          if (btn) {
            btn.style.pointerEvents = "auto";
            btn.style.opacity = "1";
            clearInterval(checkBtn);
            // console.log("Recurpay button enabled");
          }
        }, 300);
      }
      enableRecurpayButton();
    // Select first dropdown frequency item
    const ul = document.querySelector(".dropdown-custom-frequency-list");
    if (!ul) return;
    const firstLi = ul.querySelector(".dropdown-custom-frequency-item");
    if (!firstLi) return;

    setTimeout(() => {
      firstLi.click();
      // let recurpay__group_title_one_clone = document.querySelector(".recurpay__group_title-one-clone.recurpay-cloned-offer-info .recurpay__group_subtitle");
      // recurpay__group_title_one_clone.style.display = "none";
      const priceSpan = firstLi.querySelector("span:last-of-type");
      const price = priceSpan ? priceSpan.textContent : "0";
      const dropdownSelected = document.querySelector(".dropdown-custom-selected");
      if (dropdownSelected) {
        let dropdownPriceSpan = dropdownSelected.querySelector("span:last-of-type");
        if (!dropdownPriceSpan) {
          dropdownPriceSpan = document.createElement("span");
          dropdownSelected.appendChild(dropdownPriceSpan);
        }
        dropdownPriceSpan.textContent = price;
      }
      const offerContainer = document.querySelector(".offer-price-container");
      if (offerContainer) offerContainer.textContent = "";
      

    }, 500);

  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
(function () {
  function handleRecurpayWidget() {
    const widget = document.querySelector(".recurpay-pdp-widget");
     let recurpay__action = document.querySelector(".recurpay__action button");
    if (!widget || widget.dataset.listenerAttached) return;
    widget.dataset.listenerAttached = "true";
    widget.addEventListener("click", function (e) {
      const oneTime = e.target.closest(
        '.recurpay__widget_container[data-type="onetime-purchase"]'
      );
      const subscription = e.target.closest(
        '.recurpay__widget_container[data-type="subscription-purchase"]'
      );

      if (oneTime) handleOneTimePurchase();
      if (subscription) handleSubscriptionPurchase();
    });
    // addCustomSubscription();
  }
  function handleOneTimePurchase() {
      let parent = document.querySelector('.recurpay__group_label[for="recurpay__onetime_radio"]');
      if (parent) {
          let cstm_onetime_price = parent.querySelector('.recurpay__group_selling_price span.money').textContent.trim();
          // console.log("-----cstm_onetime_price------"+cstm_onetime_price);
          // alert(cstm_onetime_price);
          // console.log("--------------------cstm_onetime_price"+cstm_onetime_price);
          $('.price-item.price-item--regular.signle_price').text(cstm_onetime_price);
          $('.main_product_price .price-item.price-item--sale.price-item--last').text(cstm_onetime_price);
          
      }

      
      const block = document.querySelector(".shopify-block.shopify-app-block");
      const price = document.querySelector(".main_product_price");
      const button = document.querySelector(".customize_button");

      if (block) {
        block.classList.add("one-time-purchase");
        block.classList.remove("two-time-purchase");
      }

      if (price) price.style.display = "inline-block";
      if (button) button.style.display = "inline-block";




  }
  function handleSubscriptionPurchase() {
    const block = document.querySelector(".shopify-block.shopify-app-block");
    const price = document.querySelector(".main_product_price");
    const button = document.querySelector(".customize_button");

    if (block) {
      block.classList.add("two-time-purchase");
      block.classList.remove("one-time-purchase");
    }

    if (price) price.style.display = "none";
    if (button) button.style.display = "none";

    buildFrequencyDropdown();
   
  }

  function buildFrequencyDropdown() {
    const select = document.querySelector(
      ".recurpay__frequency_select.recurpay__frequency"
    );

    if (!select) return;
    if (document.querySelector(".dropdown-custom-wrapper")) return;

    select.style.display = "none";

    const basePriceEl = document.querySelector(
      ".recurpay__group_selling_price.recurpay__group_discounted_price .money"
    );

    const basePriceText = basePriceEl
      ? basePriceEl.textContent.trim()
      : "₹0";

    const currency = basePriceText.match(/[^\d.,]/)?.[0] || "₹";
    const numericBasePrice = parseFloat(
      basePriceText.replace(/[^\d.]/g, "")
    ) || 0;

    const wrapper = document.createElement("div");
    wrapper.className = "dropdown-custom-wrapper";

    const label = document.createElement("label");
    label.className = "dropdown-custom-label";
    label.textContent = "Choose Frequency";

    const selectedDiv = document.createElement("div");
    selectedDiv.className = "dropdown-custom-selected";
    selectedDiv.textContent = "Choose Frequency";

    const ul = document.createElement("ul");
    ul.className = "dropdown-custom-frequency-list";

    wrapper.appendChild(label);
    wrapper.appendChild(selectedDiv);
    wrapper.appendChild(ul);

    select.parentNode.insertBefore(wrapper, select.nextSibling);

    const badgeMap = {};
    document.querySelectorAll(
      ".subscription_badge_plan .frequency_subscription_item"
    ).forEach(item => {
      const planName = item.dataset.planName?.trim();
      const badgeSpan = item.querySelector(".frequency_badge");
      if (planName && badgeSpan) {
        badgeMap[planName] = badgeSpan.textContent.trim();
      }
    });

    Array.from(select.options).forEach(option => {

      const li = document.createElement("li");
      li.classList.add("dropdown-custom-frequency-item", "recurpay__plan");

      const cleanText = option.textContent.trim();
      const discountPercent =
        parseFloat(option.dataset.planDiscount) || 0;

      const discountedPrice =
        numericBasePrice -
        (numericBasePrice * discountPercent) / 100;

      const finalPrice =
        discountPercent > 0
          ? discountedPrice
          : numericBasePrice;
      li.appendChild(
        document.createTextNode(cleanText + " ")
      );
      if (badgeMap[cleanText]) {
        const badge = document.createElement("span");
        badge.className = "frequency_badge";
        badge.textContent = badgeMap[cleanText];
        li.appendChild(badge);
      }

      const priceSpan = document.createElement("span");
      priceSpan.className = "frequency_price";
      priceSpan.textContent =
        currency + finalPrice.toFixed(0);

      li.appendChild(priceSpan);

      Object.keys(option.dataset).forEach(key => {
        li.dataset[key] = option.dataset[key];
      });

      li.addEventListener("click", function () {

        document
          .querySelectorAll(".dropdown-custom-frequency-item.recurpay__plan")
          .forEach(item => item.classList.remove("active","selected-box"));

        li.classList.add("active");
        li.classList.add("selected-box");


    let planId = $(this).data('plan');


    $('.recurpay__frequency_select option').removeAttr('selected');

  
    let matchingOption = $('.recurpay__frequency_select option').filter(function () {
        return $(this).data('plan') == planId;
    });


    matchingOption.attr('selected', 'selected');
    $('.recurpay__frequency_select').trigger('change');
       if (select) {
            const optionToSelect = select.querySelector(
              `option[data-selling-plan="${option.dataset.sellingPlan}"]`
            );

            if (optionToSelect) {
              select.value = optionToSelect.value;
              optionToSelect.selected = true;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

        document
          .querySelectorAll(".recurpay_selling_plan_id")
          .forEach(el =>
            el.value = option.dataset.sellingPlan
          );

        const selectedPrice = priceSpan.textContent.trim().replace(/\.00\b/, '');
        // alert("selectedPrice"+selectedPrice);
        document.querySelectorAll(
          '.price-item.price-item--regular.signle_price, .price__sale .price-item.price-item--sale.price-item--last'
        ).forEach(el => el.textContent = selectedPrice);
          let moneyElements = document.querySelectorAll(
            '.recurpay__group_selling_price.recurpay__group_discounted_price span.money'
          );
          // console.log("---------------moneyElements"+moneyElements)
          // moneyElements.forEach(el => {
          //   el.innerHTML = selectedPrice;

          //   let selectedBox = document.querySelector(".selected-qnty-box[checked]");
          //   if (!selectedBox) return;

          //   let priceElement = selectedBox.querySelector(".boxes-price");
          //   if (!priceElement) return;

          //   let comparePrice = parseFloat(priceElement.dataset.cprice) || 0;

          //   if (comparePrice > 0) {

          //     let strike = document.createElement("span");
          //     strike.className = "cp-strike";
          //     strike.style.textDecoration = "line-through";
          //     strike.style.color = "#888";
          //     strike.style.marginLeft = "6px";
          //     strike.textContent = "₹" + comparePrice;

          //     // ✅ money ke ANDAR add karo
          //     el.appendChild(strike);
          //   }

          // });
          moneyElements.forEach(el => {

    el.innerHTML = selectedPrice;

    // ✅ checked input find karo
    let selectedInput = document.querySelector(".input-label-wrapper input:checked");
    if (!selectedInput) return;

    let selectedBox = selectedInput.closest(".input-label-wrapper");
    if (!selectedBox) return;

    let priceElement = selectedBox.querySelector(".boxes-price");
    if (!priceElement) return;

    let comparePrice = parseFloat(priceElement.dataset.cprice) || 0;

    if (comparePrice > 0) {

        let strike = document.createElement("span");
        strike.className = "cp-strike";
        strike.style.textDecoration = "line-through";
        strike.style.color = "#888";
        strike.style.marginLeft = "6px";
        strike.textContent = " ₹" + comparePrice;

        el.appendChild(strike);
    }

});
let priceEl = this.querySelector(".frequency_price");
            let frequencyPrice = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, '')) : 0;
            // console.log("Frequency Price:", frequencyPrice);
        
                  // 👉 Get selected quantity radio
            let selectedRadio = document.querySelector('input[name="assortment"]:checked');
            let discountAmount = 0;
            if (selectedRadio) {

            let wrapper = selectedRadio.closest('.input-label-wrapper');
            let boxPriceSpan = wrapper.querySelector('.boxes-price');

            if (boxPriceSpan) {
            let cprice = parseFloat(boxPriceSpan.getAttribute('data-cprice')) || 0;
            let data_price = parseFloat(boxPriceSpan.getAttribute('data-price')) || 0;
            if (cprice > 0) {
             discountAmount = Math.max(0, cprice - frequencyPrice);
            }
            else{
              if(cprice == 0){
                 discountAmount = Math.max(0, data_price - frequencyPrice);
              }
              
            }
           }
           }

        // console.log("Discount Amount:", discountAmount);

        // 👉 Update offer container
        let offerContainer = document.querySelector(".offer-price-container");
        // if (offerContainer) {
        //     // offerContainer.textContent = "₹" + parseFloat(discountAmount).toFixed(0);
        //     offerContainer.textContent =
        //     (parseFloat(discountAmount) || 0) === 0 
        //         ? "" 
        //         : "₹" + parseFloat(discountAmount).toFixed(0);
        // }

        let discountValue = parseFloat(discountAmount) || 0;
        let offerBadge = document.querySelector(".offer-price-badge");

        if (offerContainer) {

            if (discountValue === 0) {
                offerContainer.textContent = "";


                if (offerBadge) {
                    offerBadge.style.display = "none";
                }

            } else {
                offerContainer.textContent = "₹" + discountValue.toFixed(0);

                if (offerBadge) {
                    offerBadge.style.display = "block";
                }
            }
        }

        selectedDiv.innerHTML = "";

        selectedDiv.appendChild(
          document.createTextNode(cleanText + " ")
        );

        if (badgeMap[cleanText]) {
          const badge = document.createElement("span");
          badge.className = "frequency_badge";
          badge.textContent = badgeMap[cleanText];
          selectedDiv.appendChild(badge);
        }

        const selectedPriceClone =
          document.createElement("span");
        selectedPriceClone.className = "frequency_price";
        selectedPriceClone.textContent = selectedPrice;

        selectedDiv.appendChild(selectedPriceClone);

        selectedDiv.classList.remove("active");
        ul.classList.remove("show_dropdown");
      });

      ul.appendChild(li);
    });

    selectedDiv.addEventListener("click", function (e) {
      e.stopPropagation();
      selectedDiv.classList.toggle("active");
      ul.classList.toggle("show_dropdown");
    });

    document.addEventListener("click", function () {
      ul.classList.remove("show_dropdown");
    });
  }
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector(".recurpay-pdp-widget")) {
      handleRecurpayWidget();
      obs.disconnect();
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

function handleRecurpaySubscription() {
    // One-time purchase wala part
    const oneTimeLabel = document.querySelector('.recurpay__group_label[for="recurpay__onetime_radio"] .recurpay__group_title');
    const oneCloneContainer = document.querySelector('.recurpay__group_title-one-clone');

    if (oneTimeLabel && oneCloneContainer) {
        const mainTitle = oneCloneContainer.querySelector('.recurpay__group_main_title');
        if (mainTitle && !document.querySelector('.recurpay-cloned-offer-info')) {
            oneTimeLabel.style.display = "none";
            const clone = oneCloneContainer.cloneNode(true);
            clone.style.display = "block";
            clone.classList.add("recurpay-cloned-offer-info");
            oneTimeLabel.parentNode.insertBefore(clone, oneTimeLabel.nextSibling);

            const subtitle = clone.querySelector(".recurpay__group_subtitle");
            if (subtitle) subtitle.style.display = "none";
        }
    }

    // Subscription wala part
    const subLabel = document.querySelector('.recurpay__group_label[for="recurpay__subscribe_radio"] .recurpay__group_title');
    const subCloneContainer = document.querySelector('.recurpay__group_title-two-purchase_clone');

    if (subLabel && subCloneContainer) {
        const mainTitle = subCloneContainer.querySelector('.recurpay__group_main_title');
        if (mainTitle && !document.querySelector('.recurpay-cloned-offer-subscription')) {
            subLabel.style.display = "none";
            const clone = subCloneContainer.cloneNode(true);
            clone.style.display = "block";
            clone.classList.add("recurpay-cloned-offer-subscription");
            subLabel.parentNode.insertBefore(clone, subLabel.nextSibling);
        }
    }
}

const observer = new MutationObserver((mutations, obs) => {
    handleRecurpaySubscription();
    if (document.querySelector('.recurpay-cloned-offer-subscription') && 
        document.querySelector('.recurpay-cloned-offer-info')) {
        obs.disconnect();
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

document.addEventListener('DOMContentLoaded', handleRecurpaySubscription);
window.addEventListener('load', handleRecurpaySubscription);

